import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'detailfilter'
})
export class DetailFilterPipe implements PipeTransform {

  transform(detailsList:any[],fltstr:string,summaryDetails:any) {
//console.log("DetailFilterPipe=========",detailsList,fltstr,summaryDetails)
    if(summaryDetails.length){
      const filteredList = summaryDetails.filter((element)=>{
        for(let property in element.display){
          let value = element.display[property];
          if(typeof(value)=="number"){
            value = value.toString();
          }
          if(value.toLowerCase().includes(fltstr.toLowerCase())){
            return element;
          }
        }
      })
      return filteredList;

    }else{
        return []
    }
  }
}